module.exports = __webpack_public_path__ + "img/search.7f6b7a18.png";